<template>
  <div class="classification">
    <div class="left">
      <div class="left-con">
        <div class="item"
             v-for="(item, i) in leftList"
             :key="i"
             :class="{'active': FirstId===item.goodsCategorySysId}"
             @click="leftClick(item.goodsCategorySysId)"
        >{{ item.categoryName }}</div>
      </div>
    </div>
    <div class="right">
      <div class="second-con"
         v-for="(item, i) in rightList"
         :key="i"

      >
        <div class="header-con">{{ item.categoryName }}</div>
        <div class="third-con">
          <div class="third-item"
            v-for="(item2, i2) in item.children"
            :key="i2"
             :class="{'active': ThirdId===item2.goodsCategorySysId}"
             @click="thirdClick(item.goodsCategorySysId, item2.goodsCategorySysId)"
          >{{ item2.categoryName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { listCategorySys, listChildTrees } from '@/api/mall/mallGoods'
export default {


  data(){
    return {
      leftList: [],
      rightList: [],
      FirstId: '',
      SecondId: '',
      ThirdId: '',

    }
  },
  computed: {
    ...mapGetters([
      'classificationFirst',
      // 'goodsCategorySysIdFirst',
    ])
  },
  watch: {
    classificationFirst: {
      handler(newData, oldData) {
        // console.log(newData)
        // console.log(this.goodsCategorySysIdFirst)
        if(newData.length){
          this.leftList = Object.assign([], newData)
          this.FirstId = this.goodsCategorySysIdFirst || this.leftList[0].goodsCategorySysId
          this.getListChildTrees()
        }else {
          this.$store.dispatch('app/getListCategorySys').then(res=>{
            this.FirstId = this.leftList[0].goodsCategorySysId
            this.getListChildTrees()
          })
        }
      },
      deep:true,
      immediate: true
    },
  },
  created(){

  },
  methods: {
    //点击一级分类
    leftClick(id){
      this.FirstId = id
      this.SecondId = ''
      this.ThirdId = ''
      // this.$store.dispatch('app/change_goodsCategorySysIdFirst', id)
      this.getListChildTrees()
    },
    //获取 二、三 级数据
    getListChildTrees(){
      return listChildTrees({parentId: this.FirstId}).then(res=>{
        this.rightList = res.data
      })
    },
    //点击三级分类
    thirdClick(secondId, thirdId){
      this.SecondId = secondId
      this.ThirdId = thirdId

      this.$store.dispatch('app/change_categorySysId', [this.FirstId, this.SecondId, this.ThirdId]).then(()=>{
        // this.$router.replace('/sg/sgGoodsList?categoryLevel=3&parentId='+thirdId)
        this.$router.push({ name: 'sgGoodsList', query: { categoryLevel: 3, parentId: thirdId } })
      })
    },


  }
}
</script>

<style lang="less" scoped>
.classification{
  display: flex;position: relative;width: 100%;height: 100%;
  background-color: #fefefe;
  .left{
    width: 85px;height: 100%;background-color: #fff;
    overflow: hidden;font-size: 15px;
    .left-con{
      width: 98px;height: 100%;overflow-y: auto;
      .item{
        height: 44px;padding: 0 16px 0 12px;position: relative;
        display: flex;justify-content: center;align-items: center;
        user-select: none;
        &.active{
          color: #1585f3;font-weight: bold;
          background-color: #f4f4f4;
          &:before{
            position: absolute;top: 0;left: 0;bottom: 0;width: 3px;
            content: '';background-color: #1585f3;border-radius: 3px;
          }
        }
      }
    }
  }
  .right{
    background-color: #f4f4f4;padding: 12px 10px 0;
    flex: 1;height: 100%;overflow-y: auto;overflow-x: hidden;
    .second-con{
      margin-bottom: 12px;user-select: none;
      background-color: #fff;border-radius: 5px;font-size: 13px;color: #333;
      .header-con{line-height: 1;padding: 15px 12px;}
      .third-con{
        padding-left: 10px;font-size: 12px;display: flex;flex-wrap: wrap;
        .third-item{
          width: 29.4%;height: 35px;background-color: #f4f4f4;
          margin-right: 10px;margin-bottom: 10px;border-radius: 5px;padding: 0 8px;
          display: inline-flex;justify-content: center;align-items: center;
          flex-grow:0;flex-shrink:0;text-align: center;user-select: none;
          &.active{

          }
        }
      }
    }
  }
}
</style>